import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { TableSpecial } from './components/TableSpecial';
import { Loading } from '../../../components/Loading';
import { RiFilePdfLine } from 'react-icons/ri';
import { ModalCommisions } from './components/ModalCommisions';
import { Search } from './components/Search';
import { FileText } from 'react-feather';
import { startloadRecepcionistas } from '../../../../app/store/empleados/thunks';

export const Commision = () => {
  const dispatch = useDispatch();
  const { isLoading, orders, dateStart, dateEnd, rows, msg } = useSelector(state => state.reportsFinance);
  let data = [...orders];
  let columns = [
    {
      header: 'FOLIO',
      dataIndex: 'FOLIO',
      classHeader: 'text-start',
      classRow: 'text-start',
    },
    {
      header: 'TECNICO',
      dataIndex: 'TECNICO',
      classHeader: 'text-start',
      classRow: 'text-start',
    },
    {
      header: 'INGRESO ANTES IVA',
      dataIndex: 'INGRESO_ANTES_IVA',
      classHeader: 'text-end',
      classRow: 'text-end',
      isTotal: true, // 👈 sumará esta columna
      renderer: (value) => Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value),
    },
    {
      header: 'COSTO DEL SERVICIO',
      dataIndex: 'COSTO_HDL',
      classHeader: 'text-end',
      classRow: 'text-end',
      isTotal: true, // 👈 sumará esta columna
      renderer: (value) => Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value),
    },
    {
      header: 'COSTO REFACCIONES',
      dataIndex: 'COSTO_REFACCIONES',
      classHeader: 'text-end',
      classRow: 'text-end',
      isTotal: true, // 👈 sumará esta columna
      renderer: (value) => Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value),
    },
    {
      header: 'UTILIDAD',
      dataIndex: 'UTILIDAD',
      classHeader: 'text-end',
      classRow: 'text-end',
      isTotal: true, // 👈 sumará esta columna
      renderer: (value) => Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value),
    },

  ];

  useEffect(() => {
    dispatch(startloadRecepcionistas());
  }, [])


  return (
    <div className='p-0'>
      <ModalCommisions />
      <h3 className="h3 mb-3 fw-bold">Comisiones </h3>
      <div className='row'>
        <div className='col-12'>
          <Search />
        </div>
      </div>
      <div className='row'>
        <div className='col-12'>
          <div className="card">
            <div className="card-header border-bottom d-flex justify-content-between align-items-center">
              <h5 className="card-title mb-0 fw-bold text-black">
                Trabajo realizado (Ordenes / Ventas): {rows}
              </h5>
              <button type="button" className="btn btn-outline-danger" data-bs-toggle="modal" data-bs-target="#detailPDFCommisions"
                onClick={() => document.dispatchEvent(new Event('generatePdfCommisions'))}

                disabled={data.length == 0}>
                < FileText size={22} /> Generar PDF
              </button>
            </div>
            <div className="card-body">
              {
                (isLoading) ? <Loading /> :
                  <TableSpecial
                    columns={columns}
                    data={data}
                    function_={[]}
                    placeholderSearch="Buscar Orden de Servicio / Venta"
                    showPagination={true}
                    showControls={true}
                    showTotals={true}
                    countRow={false} // 👈 activa el contador de filas
                    showAverage={true}  // 👈 activa fila de promedio
                  />
              }

            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
